"use strict";

var _regeneratorRuntime = require("/Users/jc/code/ui-core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.signOut = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _awsAmplify = _interopRequireWildcard(require("aws-amplify"));

var _PagePreloader = _interopRequireDefault(require("thieme-ui/core/PagePreloader"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _SignIn = _interopRequireDefault(require("../SignIn"));

var _awsExports = _interopRequireWildcard(require("../aws-exports"));

var _AuthenticatorContext = _interopRequireDefault(require("./AuthenticatorContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var log = function log(message) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var enable = true;
  var level = process.env.NODE_ENV === 'production' ? 'ERROR' : 'DEBUG';
  var logger = new _awsAmplify.Logger('Authenticator', level);

  if (enable) {
    logger.debug(message, data);
  }
};
/**
 * 1. CURRENT USER
 * 2. State ist leer (einmal rendern)
 */


var initialAuthState = {
  signOut: function signOut() {
    return _awsAmplify.Auth.signOut({
      global: true
    });
  },
  error: null,
  // TODO ... is needed?
  user: null
};

var Authenticator = function Authenticator(props) {
  var children = props.children;
  var amplifyConfig = props.amplifyConfig;
  var elements = null;

  var _useState = (0, _react.useState)(initialAuthState),
      _useState2 = _slicedToArray(_useState, 2),
      auth = _useState2[0],
      setAuth = _useState2[1];

  var _useState3 = (0, _react.useState)('mounting'),
      _useState4 = _slicedToArray(_useState3, 2),
      authState = _useState4[0],
      setAuthState = _useState4[1];

  var handleAuthState = function handleAuthState() {
    var cookieRedirectKey = 'SportThieme.url';

    var cookieRedirecValue = _jsCookie["default"].get(cookieRedirectKey);

    var cookieStorage = _awsExports["default"].Auth.cookieStorage;
    var _window$location = window.location,
        hostname = _window$location.hostname,
        origin = _window$location.origin;

    _awsAmplify.Auth.currentAuthenticatedUser({
      bypassCache: true
    }).then(function (user) {
      log('authenticated');

      if (cookieRedirecValue) {
        _jsCookie["default"].remove(cookieRedirectKey, cookieStorage);

        window.location = cookieRedirecValue;
      } else {
        setAuth(_objectSpread({}, auth, {
          user: user
        }));
        setAuthState('signedIn');
      }
    })["catch"](function (e) {
      if (process.env.NODE_ENV === 'production' && hostname !== _awsExports.SPORT_THIEME_DOMAIN) {
        if (!cookieRedirecValue) {
          _jsCookie["default"].set(cookieRedirectKey, origin, cookieStorage);
        }

        window.location = "//".concat(_awsExports.SPORT_THIEME_DOMAIN);
      } else {
        log('not authenticated', e);
        setAuthState('signIn');
      }
    });
  }; // configuration


  (0, _react.useEffect)(function () {
    /**
     * USE DEFAULT localhost config in envoirment development¸
     */
    if (process.env.NODE_ENV === 'development') {
      amplifyConfig = {};
    }

    var configuration = Object.assign({}, _awsExports["default"], amplifyConfig);
    log('CONFIGURATION', process.env.NODE_ENV);
    log('CONFIGURATION', amplifyConfig);
    log('CONFIGURATION', configuration);

    _awsAmplify["default"].configure(configuration);
  }, []); // setup Hub hook

  (0, _react.useEffect)(function () {
    log('useEffect.HUB');

    _awsAmplify.Hub.listen('auth', function (_ref) {
      var payload = _ref.payload;
      log('HUB message coming in with event:', payload.event);

      switch (payload.event) {
        case 'signIn':
          log('event.signIn', payload);
          handleAuthState();
          break;

        case 'signIn_failure':
          log('event.signIn_failure', payload);
          setAuthState('signIn');
          break;

        case 'signOut':
          log('event.signOut', payload);
          setAuthState('signIn');
          break;

        default:
          break;
      }
    });

    return function () {
      return _awsAmplify.Hub.remove('auth');
    };
  }, []); // check currentUser hook

  (0, _react.useEffect)(function () {
    log('useEffect.AUTH');
    handleAuthState();
  }, []); // refresh token hook

  (0, _react.useEffect)(function () {
    log('useEffect.TOKEN');
    var REFRESH_TIME = 3300000; // 55 min

    var refreshSesssion =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var cognitoUser, session;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                log('refresh');
                _context.prev = 1;
                _context.next = 4;
                return _awsAmplify.Auth.currentAuthenticatedUser();

              case 4:
                cognitoUser = _context.sent;
                _context.next = 7;
                return _awsAmplify.Auth.currentSession();

              case 7:
                session = _context.sent;
                cognitoUser.refreshSession(session.getRefreshToken(), function (err, newSession) {
                  if (err) {
                    log('refreshSessionError', err);
                  } else {
                    log('refreshSessionSuccess', newSession);
                  }
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                log('Unable to refresh Token:', _context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11]]);
      }));

      return function refreshSesssion() {
        return _ref2.apply(this, arguments);
      };
    }();

    var interval = setInterval(refreshSesssion, REFRESH_TIME);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  /**
   * rendering logic
   */

  if (authState === 'mounting') {
    elements = _react["default"].createElement(_PagePreloader["default"], null);
  }

  if (authState === 'signIn') {
    elements = _react["default"].createElement(_SignIn["default"], null);
  }

  if (authState === 'signedIn') {
    elements = _react["default"].Children.toArray(children).map(function (element) {
      return _react["default"].cloneElement(element, {
        auth: auth
      });
    });
  }

  log('render', {
    auth: auth,
    authState: authState
  });
  return _react["default"].createElement(_AuthenticatorContext["default"].Provider, {
    value: auth
  }, elements);
};

Authenticator.defaultProps = {
  amplifyConfig: {}
};
Authenticator.propTypes = {
  children: _propTypes["default"].any.isRequired,
  amplifyConfig: _propTypes["default"].object
};

var signOut = function signOut() {
  return _awsAmplify.Auth.signOut();
};

exports.signOut = signOut;
var _default = Authenticator;
exports["default"] = _default;